<template>
  <div>
    <b-list-group flush class="mb-2 mt-2 cust-overflow-y-light h-full h-45vh">
      <!-- <b-list-group-item action class="cursor-pointer">
        <b-row align-v="center">
          <b-col md="auto" class="pl-0">
            <div
              class="
                rounded-full
                w-10
                h-10
                flex
                justify-center
                items-center
                bg-primary-tranparent
              "
            >
              <img
                src="https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg"
                class="w-10 h-10 rounded-full"
              />
            </div>
          </b-col>
          <b-col class="pl-0">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4 class="mb-0 text-sm font-semibold">Caregiver Saathi</h4>
                <p class="text-xs text-muted font-normal mb-0">
                  #Brained-suite
                </p>
              </div>
              <base-button size="sm" type="primary">Join</base-button>
            </div>
          </b-col>
        </b-row>
      </b-list-group-item> -->
      <b-list-group-item
        action
        class="cursor-pointer chnl-left-cust-bg"
        v-for="channel in ChannelList"
        :key="channel._id"
        :active="selectedChannel && selectedChannel._id === channel._id"
      >
        <b-row align-v="center" @click="handleChannelClick(channel)">
          <b-col md="auto" class="cust-rounded-md mob-w-auto">
            <div
              class="rounded-full w-10 h-10 flex justify-center items-center bg-primary-tranparent"
            >
              <img
                :src="channelImage(channel)"
                class="w-10 h-10 rounded-full object-cover hi"
              />
            </div>
          </b-col>
          <b-col class="pl-0">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h4 class="mb-0 text-sm font-semibold">
                  {{ channel.name }}
                </h4>
                <p class="text-xs text-muted font-normal mb-0 ellipsis-1">
                  {{ channel.description }}
                </p>
              </div>
              <b-badge
                variant="info"
                class="cust-badge-ch"
                v-if="channel.isJoined"
                >Request Sent</b-badge
              >
              <JoinChannel v-else-if="!channel.isMember" :channel="channel" />
            </div>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import JoinChannel from "./JoinChannel";

export default {
  components: {
    JoinChannel,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("channel", {
      selectedChannel: "selectedChannel",
    }),
    ...mapGetters("channel", {
      ChannelList: "currentUserChannel",
    }),
    // isChannelDeleted() {
    //   return this.ChannelList[0].isDeleted === false;
    // },
    // channelName(){
    //   return {

    //   }
    // }
  },
  watch: {
    async selectedChannel(newVal, old) {
      if (newVal._id && newVal._id !== (old && old._id)) {
        let loader = this.$loading();
        await this.getChannelPosts(newVal._id);
        loader.close();
      }
    },
  },
  methods: {
    async handleChannelClick(channel) {
      if (!channel.isMember) return;
      let loader = this.$loading();
      try {
        await this.getChannelPosts(channel._id);
        await this.$store.dispatch("channel/GetChannel", {
          channelID: channel._id,
        });
        // await this.$store.commit("")
        // console.log(this.selectedChannel._id);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    channelImage(channel) {
      return `${this.$imageURL}/${channel.picture}`;
    },
    async getChannelPosts(channelId) {
      await this.$store.dispatch("posts/getChannelPosts", channelId);
    },
  },
  async mounted() {
    if (this.selectedChannel) {
      await this.getChannelPosts(this.selectedChannel._id);
    }
  },
};
</script>
